import useAddEventListener, {
  EventListenerConfig,
} from './useAddEventListener';

type UseKeyDownOptions = {
  onKeyDown: (e: KeyboardEvent) => void;
} & EventListenerConfig;

export default function useKeyDown({ onKeyDown, ...props }: UseKeyDownOptions) {
  useAddEventListener({
    event: 'keydown',
    handler: onKeyDown,
    ...props,
  });
}
